import {
  addBackLink,
  addTitleRow,
  applyColumnLayout,
  BODY_FONT,
  DATA_START_ROW,
  HEADER_FONT_12,
  HEADER_ROW,
  hideColumnsAfter,
  hideRowsThrough,
  SPACER_ROW,
  TEMPLATE_ROW,
  setCell,
  setValueDataRow,
  setupSheetView,
  THIN_BLACK,
} from "./detailSheetCommon";
import { COL_D, COL_E, COL_F, COL_G } from "./principle1DetailHelpers";

const THIN = { style: "thin", color: { argb: "FF000000" } };
const MEDIUM = { style: "medium", color: { argb: "FF000000" } };

const SHEET_TITLE =
  " Awareness programmes conducted for value chain partners on any of the Principles during the financial year";

const HEADERS = [
  { col: COL_D, label: "Sr. No." },
  { col: COL_E, label: "Total number of awareness programmes held" },
  { col: COL_F, label: "Topics / principles covered under the training" },
  {
    col: COL_G,
    label:
      "Percentage of value chain partners covered (by value of business done with such partners) under the awareness programmes",
  },
];

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 14,
  E: 25.54296875,
  F: 68.7265625,
  G: 68.7265625,
  H: 9.1796875,
  I: 9.1796875,
  J: 9.1796875,
};

export const SHEET_NAME = "Programmes for value chain";

function applyProgrammesTitleBorders(ws) {
  const specs = ["ttt-", "t-t-", "t-t-", "t-tt"];
  const map = { t: THIN, m: MEDIUM };
  specs.forEach((spec, index) => {
    ws.getCell(8, COL_D + index).border = {
      top: map[spec[0]],
      left: spec[1] !== "-" ? map[spec[1]] : undefined,
      bottom: spec[2] !== "-" ? map[spec[2]] : undefined,
      right: spec[3] !== "-" ? map[spec[3]] : undefined,
    };
  });
}

function applyTableHeaderBorders(ws, row) {
  for (let col = COL_D; col <= COL_G; col += 1) {
    ws.getCell(row, col).border = THIN_BLACK;
  }
}

function applySpacerRowBorders(ws, row) {
  const specs = ["ttt-", "t-t-", "t-t-", "t-tt"];
  const map = { t: THIN, m: MEDIUM };
  specs.forEach((spec, index) => {
    ws.getCell(row, COL_D + index).border = {
      top: map[spec[0]],
      left: spec[1] !== "-" ? map[spec[1]] : undefined,
      bottom: spec[2] !== "-" ? map[spec[2]] : undefined,
      right: spec[3] !== "-" ? map[spec[3]] : undefined,
    };
  });
}

function topicsText(value) {
  if (Array.isArray(value)) {
    const filtered = value.filter(
      (item) => String(item).trim().toLowerCase() !== "select all"
    );
    return filtered.length ? filtered.join(", ") : ".";
  }
  if (value === null || value === undefined || value === "") return ".";
  return String(value);
}

function formatPercent(value) {
  return displayText(value);
}

function displayText(value) {
  if (value === null || value === undefined || value === "") return ".";
  return String(value);
}

export function buildProgrammesForValueChainSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });
  applyColumnLayout(ws, WIDTHS, ["A", "B"]);
  hideColumnsAfter(ws, 10);
  setupSheetView(ws, { xSplit: 3, ySplit: 11, topLeftCell: "D12", zoomScale: 80 });
  hideRowsThrough(ws, 5);
  addBackLink(ws, COL_G);

  addTitleRow(ws, COL_D, COL_G, SHEET_TITLE, { height: 30 });
  applyProgrammesTitleBorders(ws);

  applyTableHeaderBorders(ws, HEADER_ROW);
  ws.getRow(HEADER_ROW).height = 29;
  HEADERS.forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      font: HEADER_FONT_12,
      bold: true,
      bordered: false,
      align: "center",
    });
  });

  applyTableHeaderBorders(ws, TEMPLATE_ROW);
  for (let col = COL_D; col <= COL_G; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, ".", { bordered: false, font: BODY_FONT });
  }
  ws.getRow(TEMPLATE_ROW).height = 29;
  ws.getRow(TEMPLATE_ROW).hidden = true;

  ws.mergeCells(SPACER_ROW, COL_D, SPACER_ROW, COL_G);
  applySpacerRowBorders(ws, SPACER_ROW);
  ws.getRow(SPACER_ROW).height = 30;

  const programs = Array.isArray(sectionC?.principle1?.leadershipIndicator?.awarenessProgram)
    ? sectionC.principle1.leadershipIndicator.awarenessProgram
    : [];
  const rows = programs.length ? programs : [{}];

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    const topics = topicsText(item?.topicsPrinciples);
    setValueDataRow(ws, row, COL_D, COL_G, item, [
      { col: COL_D, value: String(idx + 1), align: "center", fill: undefined, font: BODY_FONT },
      { col: COL_E, value: displayText(item?.totalProgram), align: "center" },
      { col: COL_F, value: topics, align: "left" },
      { col: COL_G, value: formatPercent(item?.percentage), align: "center" },
    ]);
    ws.getRow(row).height = Math.max(30, Math.ceil(topics.length / 40) * 15);
  });

  hideRowsThrough(ws, 5);
  return ws;
}
